import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireModule, requireUserMgmt }) {
  const { user, loading, canRead, canManageUsers } = useAuth();
  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-[#f9f8f6]"
      >
        <div className="font-serif text-2xl text-[#234333]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;

  if (requireUserMgmt && !canManageUsers) {
    return <Forbidden />;
  }
  if (requireModule && !canRead(requireModule)) {
    return <Forbidden />;
  }

  return children;
}

function Forbidden() {
  return (
    <div
      data-testid="forbidden-page"
      className="p-12 max-w-2xl mx-auto bg-white border border-[#e5e0d8] rounded-sm mt-12 text-center"
    >
      <div className="font-serif text-3xl text-[#1c1a17] mb-3">Access Denied</div>
      <div className="text-sm text-[#6b655b]">
        You don't have permission to view this page. Please contact a Super Admin if you need access.
      </div>
    </div>
  );
}
